import React from 'react';

const AffiliateLinkTag = ({ color = '#757575', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M11.6707 3.33203H8.32902C5.17849 3.33203 3.60323 3.33203 2.62449 4.30834C1.9506 4.98056 1.7407 5.93486 1.67532 7.48992C1.66235 7.79831 1.65587 7.95251 1.71346 8.05538C1.77104 8.15826 2.00094 8.28664 2.46074 8.54341C2.97138 8.82858 3.31656 9.37343 3.31656 9.9987C3.31656 10.624 2.97138 11.1688 2.46074 11.454C2.00095 11.7107 1.77104 11.8391 1.71346 11.942C1.65587 12.0449 1.66235 12.1991 1.67532 12.5075C1.7407 14.0625 1.9506 15.0168 2.62449 15.6891C3.60323 16.6654 5.17849 16.6654 8.32902 16.6654H11.6707C14.8212 16.6654 16.3964 16.6654 17.3752 15.6891C18.0491 15.0168 18.259 14.0625 18.3244 12.5075C18.3373 12.1991 18.3438 12.0449 18.2862 11.942C18.2286 11.8391 17.9987 11.7108 17.5389 11.454C17.0283 11.1688 16.6831 10.624 16.6831 9.9987C16.6831 9.37343 17.0283 8.82858 17.5389 8.54341C17.9987 8.28664 18.2286 8.15826 18.2862 8.05539C18.3438 7.95251 18.3373 7.79831 18.3244 7.48992C18.259 5.93486 18.0491 4.98056 17.3752 4.30834C16.3964 3.33203 14.8212 3.33203 11.6707 3.33203Z"
        stroke={color}
        strokeWidth="1.25"
      />
      <path d="M7.5 12.5L12.5 7.5" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path
        d="M12.9167 12.0833C12.9167 12.5436 12.5436 12.9167 12.0833 12.9167C11.6231 12.9167 11.25 12.5436 11.25 12.0833C11.25 11.6231 11.6231 11.25 12.0833 11.25C12.5436 11.25 12.9167 11.6231 12.9167 12.0833Z"
        fill={color}
      />
      <path
        d="M8.75016 7.91536C8.75016 8.3756 8.37707 8.7487 7.91683 8.7487C7.45659 8.7487 7.0835 8.3756 7.0835 7.91536C7.0835 7.45513 7.45659 7.08203 7.91683 7.08203C8.37707 7.08203 8.75016 7.45513 8.75016 7.91536Z"
        fill={color}
      />
    </svg>
  );
};

export default React.forwardRef(AffiliateLinkTag);
